module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAQCAMAAAACnf78AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAGUExURf///////1V89WwAAAABdFJOU+2eXUajAAAAFUlEQVQI12NgYAQCBjAJpGlIQSwCABSQAF2Tfd/mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/check-in-expanded-01-copy-10-path-4@2x.png
// module id = 171
// module chunks = 0